import { collapseAndDisableSection, expandAndEnableSection } from "./modules/collapse";

export function CustomCheckoutFieldListeners() {
  const verzendContainer = document.getElementById("order_review");

  if (verzendContainer) {
    verzendContainer.addEventListener("click", () => {
      // shippingDialog();
      toggleMomentSelectors();
    });
  }

  jQuery(document.body).on("updated_checkout", () => {
    toggleMomentSelectors();
    console.log("updated_checkout jq");
  });




}

// $( document.body ).trigger( 'init_checkout' );
// $( document.body ).trigger( 'payment_method_selected' );
// $( document.body ).trigger( 'update_checkout' );
// $( document.body ).trigger( 'updated_checkout' );
// $( document.body ).trigger( 'checkout_error' );
// $( document.body ).trigger( 'applied_coupon_in_checkout' );
// $( document.body ).trigger( 'removed_coupon_in_checkout' );

function toggleMomentSelectors() {
  const pickup = document.querySelector("[id*='local_pickup']");
  const sectionBezorg = document.getElementById("bezorgmoment_wrapper");
  const sectionAfhaal = document.getElementById("afhaal");

  if (!pickup) {
    collapseAndDisableSection(sectionAfhaal);
    if (document.body.innerHTML.includes('Er zijn geen verzendmethoden beschikbaar')
      || document.body.innerHTML.includes(' je adres in om de verzendop')) {
      collapseAndDisableSection(sectionBezorg);
    } else {
      expandAndEnableSection(sectionBezorg);
    }

    return;
  }

  if (pickup.checked || pickup.type == "hidden") {
    collapseAndDisableSection(sectionBezorg);
    expandAndEnableSection(sectionAfhaal);
  } else {
    collapseAndDisableSection(sectionAfhaal);
    expandAndEnableSection(sectionBezorg);
  }
}

function shippingDialog() {
  const localPickup = document.querySelector("[id*='local_pickup']");
  if (!localPickup) {
    return;
  }

  const shippingDialog = document.getElementById("shipping_dialog");
  if (!shippingDialog) {
    return;
  }

  shippingDialog.classList.add("hidden-force");
  // if pickup is the only option
  if (localPickup.type === "hidden") {
    shippingDialog.classList.remove("hidden-force");
  }
}
